import Layout from "@/views/layout";

const agencyRouter = {
  path: "/agency",
  name: "Agency",
  component: Layout,
  meta: { title: "经销商模块" },
  children: [
    {
      path: "adApply",
      name: "AdApply",
      component: () => import("@/views/agency/adApply.vue"),
      meta: { title: "广告申请" }
    },
    {
      path: "ad-agreement",
      name: "AdAgreement",
      component: () => import("@/views/agency/adAgreement.vue"),
      meta: { title: "协议填写" }
    },
    {
      path: "preview",
      name: "Preview",
      component: () => import("@/views/agency/preview.vue"),
      meta: { title: "预览" }
    },
    {
      path: "editAd",
      name: "EditAd",
      component: () => import("@/views/agency/editAd.vue"),
      meta: { title: "编辑" }
    },
    {
      path: "ad-agreement-detail",
      name: "AgencyAgreementDetail",
      component: () => import("@/views/agency/agreementDetail.vue"),
      meta: { title: "协议详情" }
    },
    {
      path: "ad-detail",
      name: "AdDetail",
      component: () => import("@/views/agency/adDetail.vue"),
      meta: { title: "广告详情" }
    },
    {
      path: "history",
      name: "History",
      component: () => import("@/views/agency/history.vue"),
      meta: { title: "历史记录" }
    },
    {
      path: "refund",
      name: "Refund",
      component: () => import("@/views/agency/refund.vue"),
      meta: { title: "广告报销" }
    },
    {
      path: "reimbursement",
      name: "Reimbursement",
      component: () => import("@/views/agency/reimbursement.vue"),
      meta: { title: "广告报销" }
    },
    {
      path: "deal-detail",
      name: "DealDetail",
      component: () => import("@/views/agency/dealDetail.vue"),
      meta: { title: "协议详情" }
    }
  ]
};

export default agencyRouter;
